<template>
    <form method="post" :action="loginUrl">

        <div class="form-item">
            <label for="email-login">Votre E-Mail *</label>
            <input type="text" name="log" id="email-login" required>
        </div>

        <div class="form-item">
            <label for="password-login">Mot de passe *</label>
            <input type="password" name="pwd" id="password-login" required>
        </div>

        <div class="cta">
            <input name="rememberme" type="checkbox"
                   class="ge"
                   id="remember"
                   value="remember">
            <label for="remember">Se souvenir de moi</label>
            <input type="hidden" name="redirect_to" :value="redirect" />
            <button type="submit" class="btn chevron">Connexion</button>
        </div>

    </form>
</template>

<script>
    export default {
        data: () => ({
            loginUrl: window.GrandsEspaces.loginUrl,
            redirect: location.href
        }),
        props: {
            isoption: {
                type: Boolean,
                required: true,
            },
        },
        watch: {
            isoption: function (val) {
                this.redirect = val ? location.href + '?is_option=true' : location.href
            },
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/LoginForm.vue